import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  all: [],
};

export const modalitiesSlice = createSlice({
  name: 'modalities',
  initialState,
  reducers: {
    setAll: (state, action) => {
      state.all = action.payload;
    },
  },
});

export const {
  setAll,
} = modalitiesSlice.actions;

export default modalitiesSlice.reducer;
